import { render, staticRenderFns } from "./CustomHeaderTab.vue?vue&type=template&id=633d64d0&scoped=true"
import script from "./CustomHeaderTab.vue?vue&type=script&lang=js"
export * from "./CustomHeaderTab.vue?vue&type=script&lang=js"
import style0 from "./CustomHeaderTab.vue?vue&type=style&index=0&id=633d64d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d64d0",
  null
  
)

export default component.exports